// Shared helpers for the CRM dashboard
export const TIER_STYLES = {
  hot: { bg: "rgba(226,109,90,0.15)", text: "#E26D5A", border: "rgba(226,109,90,0.3)", label: "HOT" },
  warm: { bg: "rgba(212,175,55,0.15)", text: "#D4AF37", border: "rgba(212,175,55,0.3)", label: "WARM" },
  cold: { bg: "rgba(123,161,176,0.15)", text: "#7BA1B0", border: "rgba(123,161,176,0.3)", label: "COLD" },
};

export function TierBadge({ tier, pending }) {
  if (pending) {
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-[11px] tracking-wider border border-white/15 text-white/50">
        <span className="h-1.5 w-1.5 rounded-full bg-white/40 animate-pulse" /> SCORING
      </span>
    );
  }
  const s = TIER_STYLES[tier];
  if (!s) {
    return (
      <span className="inline-flex px-2.5 py-1 rounded-sm text-[11px] tracking-wider border border-white/15 text-white/50">
        —
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center px-2.5 py-1 rounded-sm text-[11px] font-medium tracking-wider"
      style={{ background: s.bg, color: s.text, border: `1px solid ${s.border}` }}
      data-testid={`tier-badge-${tier}`}
    >
      {s.label}
    </span>
  );
}

export const STATUS_OPTIONS = ["new", "contacted", "qualified", "closed", "lost"];

export const STATUS_STYLES = {
  new: "text-brand",
  contacted: "text-blue-300",
  qualified: "text-purple-300",
  closed: "text-green-400",
  lost: "text-white/40",
};

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
